import { ApiError } from '../services/api';

export function billingErrorKey(error: unknown, fallback: string): string {
  const code = error instanceof ApiError ? (error.data as { code?: string } | undefined)?.code : undefined;
  if (code === 'ALREADY_SUBSCRIBED') return 'billing.alreadySubscribed';
  if (code === 'CHECKOUT_PENDING' || code === 'BILLING_BUSY') return 'billing.checkoutPending';
  if (code === 'SUPPORT_REQUIRED') return 'billing.supportRequired';
  if (code === 'BILLING_UNAVAILABLE') return 'billing.pricingUnavailable';
  return fallback;
}
